import * as React from 'react';
import api from '../../api';
import { MediaFile } from '../../core';
import { useDataLoader } from 'react-remote-data-hooks';

interface IDownloadLink {
  file?: MediaFile;
  className?: string;
  target?: string;
}

export const DownloadLink: React.FunctionComponent<IDownloadLink> = (props) => {
  const { data: signedUrl, reload, loaded } = useDataLoader<string>(
    async (mediaFile?: MediaFile) =>
      mediaFile ? api.upload.getSignedMediaFileUrl(mediaFile) : undefined,
    [props.file]
  );

  React.useEffect(() => {
    if (loaded) {
      reload(props.file);
    }
  }, [props.file]);

  return (
    <a
      href={signedUrl}
      target={props.target}
      download={true}
      className={props.className}
    >
      {props.children}
    </a>
  );
};
